import { render, staticRenderFns } from "./AppDashboard.vue?vue&type=template&id=b1019698&scoped=true"
import script from "./AppDashboard.vue?vue&type=script&lang=js"
export * from "./AppDashboard.vue?vue&type=script&lang=js"
import style0 from "./AppDashboard.vue?vue&type=style&index=0&id=b1019698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1019698",
  null
  
)

export default component.exports